import { combineReducers } from 'redux';
import acquisition from "./dailyReport/acquisition";
import loyalty from "./dailyReport/loyalty";
import freemium from "./dailyReport/freemium";

export default combineReducers({
    acquisition,
    loyalty,
    freemium,
});



// WEBPACK FOOTER //
// ./src/reducers/app/dailyReport.js